import { QueryClient } from "@tanstack/react-query";

/**
 * Global QueryClient configuration
 * Centralized configuration for TanStack Query
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Stale time: How long data is considered fresh (5 minutes)
      staleTime: 1000 * 60 * 5,
      
      // GC time: How long unused data stays in cache (10 minutes)
      gcTime: 1000 * 60 * 10,
      
      // Retry failed requests
      retry: 1,
      
      // Retry delay
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      
      // Refetch on window focus (useful for keeping data fresh)
      refetchOnWindowFocus: false,
      
      // Refetch on reconnect
      refetchOnReconnect: true,
    },
    mutations: {
      // Retry failed mutations
      retry: 0,
    },
  },
});
